<template>
  <div class="card border-0 card-with-shadow mb-primary">
    <div class="card-header d-flex align-items-center justify-content-between p-primary bg-transparent">
      <h5  class="card-title text-muted m-0">{{ $t('participants') }}</h5>
    </div>
    <div class="card-body">
           <template v-if="Object.keys(activityParticipations).length">
          <template v-for="participant in activityParticipations">
            <div class="media d-flex align-items-center mb-3">
              <app-avatar
                  :title="participant[0].name"
                  class="mr-2"
                  avatar-class="avatars-w-40"
                  :img="''"/>
              <div class="media-body">
                {{participant[0].name}}
              </div>
            </div>
          </template>
           </template>
      <template v-else>
        {{$t('not_added_yet')}}
      </template>

    </div>
  </div>
</template>

<script>
    export default {
        name: "ParticipationInfo",
        props: ['activityParticipations'],
    }

</script>
